import { cn } from "@/lib/revive-landing/utils";

export function Input({ className, ...props }) {
  return (
    <input
      className={cn(
        "h-11 w-full rounded-xl border border-zinc-700 bg-zinc-900 px-3 text-sm text-zinc-100 outline-none ring-emerald-400 placeholder:text-zinc-500 focus:ring-2",
        className,
      )}
      {...props}
    />
  );
}
